import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { motion } from 'framer-motion';
export function Process() {
  const {
    t
  } = useLanguage();
  const steps = t('process.steps');
  const easeOutCubic = [0.33, 1, 0.68, 1];
  return <section id="proceso" className="py-20 lg:py-28 bg-brand-cream relative overflow-hidden" data-id="element-249">
      <div className="container mx-auto px-6" data-id="element-250">
        <div className="text-center max-w-2xl mx-auto mb-14" data-id="element-251">
          <span className="text-brand-dark/50 font-medium tracking-[0.25em] text-xs uppercase mb-6 block" data-id="element-252">
            {t('process.eyebrow')}
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light text-brand-dark mb-6 tracking-tight" data-id="element-253">
            {t('process.heading')}
          </h2>
          <p className="text-brand-dark/60 font-light text-lg" data-id="element-254">
            {t('process.subheading')}
          </p>
          <div className="w-12 h-px bg-brand-gold mx-auto mt-10" data-id="element-255"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 max-w-6xl mx-auto" data-id="element-256">
          {steps.map((step: any, idx: number) => <motion.div key={step.number} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.8,
          delay: idx * 0.15,
          ease: easeOutCubic
        }} className="relative" data-id="element-257">
              {/* Step number */}
              <div className="mb-6 flex items-center gap-3" data-id="element-258">
                <span className="font-serif text-3xl text-brand-gold/80 font-light italic" data-id="element-259">
                  {step.number}
                </span>
                <span className="flex-1 h-px bg-brand-stone" data-id="element-260"></span>
              </div>

              <h3 className="font-serif text-2xl text-brand-dark font-light mb-3" data-id="element-261">
                {step.title}
              </h3>
              <p className="text-brand-dark/60 font-light leading-relaxed text-sm" data-id="element-262">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}